(function () {
  'use strict';

  const selectors = [
    '[data-minimog-cart-items]',
    '[data-minimog-cart-discounts]',
    '[data-cart-subtotal]',
    '[data-minimog-gift-wrapping]'
  ];

  function getDrawer() {
    return document.querySelector('m-cart-drawer');
  }

  function getCartPage() {
    return document.querySelector('m-cart');
  }

  async function refreshSection(sectionId, container) {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const cartUrl = (window.MinimogSettings && window.MinimogSettings.routes && window.MinimogSettings.routes.cart) || (root + 'cart');
    const separator = cartUrl.includes('?') ? '&' : '?';
    const response = await fetch(cartUrl + separator + 'section_id=' + encodeURIComponent(sectionId), {
      credentials: 'same-origin',
      cache: 'no-store'
    });

    if (!response.ok) {
      throw new Error('Cart section request failed: ' + response.status);
    }

    const html = new DOMParser().parseFromString(await response.text(), 'text/html');

    for (const selector of selectors) {
      const oldElement = container.querySelector(selector);
      const newElement = html.querySelector(selector);

      if (oldElement && newElement) {
        oldElement.innerHTML = newElement.innerHTML;
      } else if (selector === '[data-minimog-cart-items]' && oldElement && !newElement) {
        throw new Error('Cart items missing from ' + sectionId);
      }
    }
  }

  function synchronizeCartState(totalQuantity) {
    if (!Number.isFinite(totalQuantity)) return;
    const isEmpty = totalQuantity === 0;

    for (const bubble of document.querySelectorAll('.m-cart-count-bubble')) {
      const header = bubble.closest('.m-header__top');
      bubble.textContent = String(totalQuantity);
      bubble.classList.toggle('m:hidden', isEmpty);
      if (header) header.classList.toggle('m-show-bubble', !isEmpty);
    }

    const drawer = getDrawer();
    const cartPage = getCartPage();
    if (drawer) {
      drawer.classList.toggle('m-cart--empty', isEmpty);
      const drawerItems = drawer.querySelector('m-cart-drawer-items');
      if (drawerItems) drawerItems.classList.toggle('m-cart--empty', isEmpty);
    }
    if (cartPage) cartPage.classList.toggle('m-cart--empty', isEmpty);
  }

  async function refreshCart(cart) {
    const drawer = getDrawer();
    const cartPage = getCartPage();
    const work = [];

    if (drawer) work.push(refreshSection('cart-drawer', drawer));
    if (cartPage) work.push(refreshSection('cart-template', cartPage));

    await Promise.all(work);
    synchronizeCartState(cart.totalQuantity);
  }

  document.addEventListener('DOMContentLoaded', function () {
    const actions = window.Shopify && window.Shopify.actions;
    if (!actions || !actions.updateCart || !actions.openCart) return;

    actions.updateCart.configure({
      eventTarget: function () {
        return document.querySelector('m-cart-drawer-items') || getCartPage() || getDrawer() || document;
      },
      async handler(defaultHandler) {
        const result = await defaultHandler();
        if (!result || !result.cart) return result;

        try {
          await refreshCart(result.cart);
        } catch (error) {
          console.error('Auvisa standard cart action: visual refresh failed', error);
          window.location.reload();
        }

        return result;
      }
    });

    actions.openCart.configure({
      handler: function (defaultHandler) {
        const drawer = getDrawer();
        if (drawer && typeof drawer.open === 'function') {
          drawer.open();
          return Promise.resolve();
        }
        return defaultHandler();
      }
    });
  });
})();